import { FileUploadDragAndDrop } from './FileUploadDragAndDrop';
import { SampleDownloadFile } from './SampleDownloadFile';

export interface ICaptureQuoteContainerOptions {
  onFileChange: (files: File[]) => void;
  sampleDownloadLink: string;
}

interface ICaptureQuoteContainerProps extends ICaptureQuoteContainerOptions {}

/**
 * -----------------------------------------------------------------------------
 * It renders the capture quote container with a sample download link and a
 * file upload drag and drop
 */
export function CaptureQuoteContainer({
  onFileChange,
  sampleDownloadLink,
}: Readonly<ICaptureQuoteContainerProps>) {
  return (
    <div
      className="
        flex flex-col items-center justify-center gap-8 border-b border-t
        border-gray-50 px-4 py-4
      "
    >
      <SampleDownloadFile sampleDownloadLink={sampleDownloadLink} />

      <div className="w-full  sm:w-7/12 sm:px-5">
        <FileUploadDragAndDrop onFileChange={onFileChange} />
      </div>
    </div>
  );
}
